import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';

@Component({
  selector: 'fcp-investment-report',
  templateUrl: './investment-report.component.html',
  styleUrls: ['./investment-report.component.scss']
})
export class InvestmentReportComponent implements OnInit {

  @Input() public data: any;
  @Output() public sendCompanySelected: EventEmitter<any>;
  @Output() public sendYearSelected: EventEmitter<any>;
  @Output() public sendMonthSelected: EventEmitter<any>;
  @Output() public sendFileSelected: EventEmitter<any>;
  @ViewChild('stepper') private myStepper: MatStepper;

  public formCompany: FormGroup;
  public formPeriod: FormGroup;
  public isLinear: boolean;
  public searchCompany: string;
  public companyLabel: string;
  public periodLabel: string;
  public companyPlaceHolder: string;
  private months: any;
  public loading: boolean;

  constructor(
    private formBuilder: FormBuilder,
  ) {
    this.sendCompanySelected = new EventEmitter();
    this.sendYearSelected = new EventEmitter();
    this.sendMonthSelected = new EventEmitter();
    this.sendFileSelected = new EventEmitter();
    this.isLinear = true;
    this.companyLabel = 'Selecione uma empresa';
    this.periodLabel = 'Selecione o período';
    this.companyPlaceHolder = 'Busque por empresas';
    this.months = [
      { month: 1, description: 'Janeiro' },
      { month: 2, description: 'Fevereiro' },
      { month: 3, description: 'Março' },
      { month: 4, description: 'Abril' },
      { month: 5, description: 'Maio' },
      { month: 6, description: 'Junho' },
      { month: 7, description: 'Julho' },
      { month: 8, description: 'Agosto' },
      { month: 9, description: 'Setembro' },
      { month: 10, description: 'Outubro' },
      { month: 11, description: 'Novembro' },
      { month: 12, description: 'Dezembro' }
    ]
  }

  ngOnInit(): void {
    window?.scrollTo(0, 0);
    this.formCompany = this.formBuilder.group({
      company: ['', Validators.required]
    });
    this.formPeriod = this.formBuilder.group({
      periodYear: ['', Validators.required],
      periodMonth: ['', Validators.required]
    });
  }

  public getCompanies() {
    this.data.showCompanyList = true;
  }

  public selectCompany(company: any) {
    this.formCompany.controls['company'].setValue(company.name);
    this.data.showCompanyList = false;
    this.sendCompanySelected.emit(company.name);
    this.nextStep();
    this.data.loading = true;
  }

  public selectYear(year: string) {
    this.sendYearSelected.emit(year);
  }

  public selectMonth(month: string) {
    this.sendMonthSelected.emit(month);
    this.nextStep();
    this.data.loading = true;
  }

  public selectFile(file: any){
    this.data.loading = true;
    this.sendFileSelected.emit(file);
  }

  public searchCompanies(event: any) {
    this.searchCompany = this.formCompany.controls['company'].value;
  }
  
  public getMonthDes(numberMonth: String): string {
    const pos = this.months.findIndex(obj => obj.month == numberMonth);
    return this.months[pos].description;
  }

  public onStepChange(event: any): void {
    if (event.selectedIndex == 0) {
      this.clearForm();
    } else if (event.selectedIndex == 1) {
      this.companyLabel = 'Empresa: ' + this.formCompany.controls['company'].value;
    } else if (event.selectedIndex == 2) {
      this.periodLabel = 'Período: ' +
         this.getMonthDes(this.formPeriod.controls['periodMonth'].value) + ' de ' +
         this.formPeriod.controls['periodYear'].value;
    }
  }

  public nextStep() {
    this.myStepper.next();
  }

  public clearForm() {
    this.searchCompany = '';
    this.companyLabel = 'Selecione uma empresa';
    this.periodLabel = 'Selecione o período';
    this.formCompany.controls['company'].setValue('');
    this.formPeriod.controls['periodYear'].setValue('');
    this.formPeriod.controls['periodMonth'].setValue('');
  }

  public scrollToTop() {
    window.scrollTo(0, 0);
  }

}
